import React from 'react'
import { translate } from 'react-i18next'

import Icon from './Icon'

export default translate('common')(({ t }) => (
  <div className="turnscreen">
    <div className="turnscreen__inner">
      <div className="turnscreen__logo">
        <Icon className="icon icon-logo" icon="turn" />
      </div>
      <p className="turnscreen__text">{ t('turnscreen.text') }</p>
    </div>
  </div>
))


// WEBPACK FOOTER //
// ./src/components/Global/TurnScreen.js